export function normalizeModelName(modelName) {
    switch (modelName) {
        case 'ehs':
        case 'mgEhs':
        case 'mg-ehs':
            return 'MG EHS';

        case 'marvel-r':
        case 'mg-marvel-r':
        case 'mgMarvelR':
        case 'marvelR':
            return 'MG MARVEL R';

        case 'zs-ev':
        case 'mg-zs-ev':
        case 'mgZsEv':
            return 'MG ZS EV';

        case 'zs':
        case 'mg-zs':
        case 'mgZs':
        case 'mgZsPetrol':
            return 'MG ZS';

        case 'hs':
        case 'mg-hs':
        case 'mgHs':
            return 'MG HS';

        case 'mg-4':
        case 'mg4':
            return 'MG4';

        case 'mg3':
            return 'MG3';

        case 'cyberster':
            return 'Cyberster';

        case 'mg-5':
        case 'mg5':
            return 'MG5';

        case 'zs-hev':
            return 'MG ZS Hybrid+';

        case 'mgs5':
            return 'MGS5 EV';

        case 'hs-hev-2025':
            return 'MG HS Hybrid+';

        case 'ehs-hev':
            return 'EHS Hybrid+';

        default:
            return '';
    }
}
